import { KimUser, KimUserStatus } from '@/typings/api/CollectorPublication'
import {
  DOWNLOAD, TableAction, TableActionsTypes,
} from '@/helpers/enums/table-actions'

const DOWNLOAD_VARIANTS: TableAction<KimUser> = {
  action: 'download:variants' as TableActionsTypes,
  icon: 'mdi-download-outline',
  tooltip: 'Скачать варианты',
  getFilter: ({ sha1_sum: sha1Sum }) => Boolean(sha1Sum),
}

export const TABLE_ACTIONS = Object.freeze([
  DOWNLOAD_VARIANTS,
  {
    ...DOWNLOAD,
    tooltip: 'Скачать критерии',
    getFilter: ({ criteria_sha1_sum: criteriaSha1Sum }: KimUser) => Boolean(criteriaSha1Sum),
  },
])
export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Пользователь',
    value: 'username',
    sortable: false,
  },
  {
    text: 'Статус',
    value: 'status',
    sortable: false,
    field: (v: KimUser['status']) => {
      switch (v) {
        case KimUserStatus.in_progress:
          return 'В процессе'
        case KimUserStatus.done:
          return 'Готово'
        case KimUserStatus.error:
          return 'Ошибка'
        case KimUserStatus.pending:
          return 'В очереди'
        case KimUserStatus.to_do:
          return 'Не запущено'
        default:
          return ''
      }
    },
  },
  {
    text: 'Бланк 1',
    value: 'is_first_blank_generation',
    sortable: false,
  },
  {
    text: 'Критерий',
    value: 'is_criteria_generation',
    sortable: false,
  },
  {
    text: 'КИМ',
    value: 'count',
    sortable: false,
    width: 136,
    getValue: (v: KimUser) => [v.generated_count, v.target_count].join('/'),
  },
])
